import { formatBRL } from '../../../../utils/currencyUtils';
import { InvoiceSummary } from '../services/invoiceSummary';
import PageTotalsBar from '../shared/PageTotalsBar';

const InvoiceTotalsBar: React.FC<{ summary: InvoiceSummary }> = ({ summary }) => (
    <PageTotalsBar
        counts={[
            { label: 'Operações', value: summary.operations.count },
            { label: 'Cedentes', value: summary.issuers.count },
            { label: 'Devedores', value: summary.payers.count },
        ]}
        natures={summary.natures}
        amounts={[
            { label: 'Valor Título', value: formatBRL(summary.titleAmount) },
            { label: 'Valor Fatura', value: formatBRL(summary.invoiceAmount), emphasis: true },
        ]}
    />
);

export default InvoiceTotalsBar;
